module.exports = __webpack_public_path__ + "static/media/virtualacc.5e483d9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/virtualacc.svg
// module id = 57
// module chunks = 0